import React from 'react';
import Button from "@components/base/Button/Button";
import language from "@lang/language";
import {useServicePriceContext} from "@contexts/ContextServicePriceProvider";
import {FormatPrice} from "@helpers/HelperFunc";
import useDataFileAction from "@hooks/useDataFileAction";

const ButtonOrder = ({serviceType = 'Plan', term = 12, yearPrice = false, customPrice = null}) => {
	const contextPrice = useServicePriceContext();
	const {executeAction} = useDataFileAction();

	let lowestPriceFormatted = '';
	if (customPrice === null) {
		const lowestPrice = contextPrice.getLowestPrice(serviceType, term, yearPrice);
		lowestPriceFormatted = FormatPrice(lowestPrice);
	} else {
		lowestPriceFormatted = customPrice;
	}

	return (
	  <Button
		value={language.orderFrom + ' ' + lowestPriceFormatted + ' ' + language.eurM}
		onClick={() => executeAction({
			buttonAction: 'NavigateToTab',
			buttonParams: ['prices']
		})}
		layout={'defaultWhiteBorder'}
	  />
	);
};

export default ButtonOrder;